import React from 'react'
import Copyright from '../../components/copyright'

class ContactForm extends React.Component {
  constructor() {
    super()

    this.state = {
      name: '',
      email: '',
      _subject: '',
      message: '',
      special: ''
    }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange = (e) => {
    let newState = {}

    newState[e.target.name] = e.target.value

    this.setState(newState)
  }

  render(){
    return (
      <div>
        <h1>Contact</h1>
        <form action="https://formspree.io/oldawgsolutions@gmail.com" method="POST" autoComplete="off">
          <p>Your Name (required)<br />
            <span><input type="text" name="name" autoComplete="off" onChange={this.handleChange} value={this.state.name} size="40" aria-required="true" aria-invalid="false" /></span>
          </p>
          <p>Your Email (required)<br />
            <span><input type="email" name="email" autoComplete="off" onChange={this.handleChange} value={this.state.email} size="40" aria-required="true" aria-invalid="false" /></span>
          </p>
          <p>Subject<br />
            <span><input type="text" name="_subject" autoComplete="off" onChange={this.handleChange} value={this.state._subject} size="40" aria-invalid="false" /></span>
          </p>
          <p>Your Message<br />
            <span><textarea name="message" cols="40" autoComplete="off" rows="10" onChange={this.handleChange} value={this.state.message} aria-invalid="false"></textarea></span>
          </p>
          <br/>
          <p>
            <input type="submit" value="Send" size="40" />
          </p>
        </form>
        <br/>
        <Copyright copyholder='Ol&#039; Dawg.com' />
      </div>
      )
    }
}

export default ContactForm